import React, { useMemo } from 'react';
import AssignmentHistoryTimeline from './AssignmentHistoryTimeline';

const ISLEM_TO_DURUM = {
  Atandi: 'Atandı',
  Degistirildi: 'Değiştirildi',
  Kaldirildi: 'İptal Edildi',
};

/**
 * SK teknik servis atama geçmişi.
 * history boşsa serviceRecord üzerinden oluşturma ataması türetilir.
 */
const TechServiceAssignmentHistory = ({ history, serviceRecord }) => {
  const mapped = useMemo(() => {
    let source = Array.isArray(history) && history.length > 0 ? history : null;

    if (!source) {
      const ts = serviceRecord?.aktifAtamaTeknikServis;
      const tsIdFromIds = Array.isArray(serviceRecord?.teknikServisIds)
        ? serviceRecord.teknikServisIds[0]
        : null;
      const id = ts?.id || ts?._id || tsIdFromIds || null;
      const ad = ts?.ad || '';
      if (!id && !ad) return [];

      const olusturan = serviceRecord?.olusturanKullanici;
      const yapanAdi = olusturan
        ? (`${olusturan.ad || olusturan.name || ''} ${olusturan.soyad || olusturan.surname || ''}`.trim()
          || olusturan.kullaniciAdi
          || '')
        : '';

      source = [{
        teknikServisId: id ? String(id) : null,
        teknikServisAdi: ad,
        islem: 'Atandi',
        yapanKullaniciAdi: yapanAdi,
        tarih: serviceRecord?.olusturmaTarihi || serviceRecord?.createdAt || null,
        gerekce: 'Servis kaydı oluşturulurken atandı',
      }];
    }

    return source.map((g) => {
      const onceki = g.oncekiTeknikServisAdi ? String(g.oncekiTeknikServisAdi).trim() : '';
      const atanan = g.teknikServisAdi ? String(g.teknikServisAdi).trim() : '';
      let atananAdi = atanan || '—';
      if (g.islem === 'Degistirildi' && onceki) {
        atananAdi = `${atanan || '—'} ← ${onceki}`;
      }
      return {
        atamaTipi: 'Teknik Servis',
        durum: ISLEM_TO_DURUM[g.islem] || g.islem || '—',
        tarih: g.tarih,
        atananAdi,
        atamaYapan: g.yapanKullaniciAdi || '',
        gerekce: g.gerekce || '',
      };
    });
  }, [history, serviceRecord]);

  if (!mapped.length) return null;

  return (
    <div className="kayit-bilgi-panel kayit-bilgi-panel--flush">
      <AssignmentHistoryTimeline
        history={mapped}
        title="Teknik Servis Atama Geçmişi"
      />
    </div>
  );
};

export default TechServiceAssignmentHistory;
